// L'AVVISO DELLO STATO DELL'ACCOUNT (2026-09-13).
//
// Due muri, non uno: lo SPAZIO e il NUMERO DI FILE. Il secondo mancava, e si
// e' visto — su un piano gratuito con 6,4 MB usati su 1 GB la barra diceva
// "1017,6 MB liberi" mentre non si poteva caricare piu' niente, perche' i 50
// file erano finiti. Spazio quasi tutto libero e nessuna possibilita': mezza
// verita' e' peggio di nessuna.
//
// DUE SOGLIE, con lo stesso significato per tutti e due i muri:
//   95%   rosso — non e' piu' un promemoria: stai per non poter caricare.
//         NON si chiude.
//  100%   rosso — non puoi piu' caricare. NON si chiude, e dice cosa fare.
//
// L'80% NON HA PIU' UNA FASCIA (2026-09-13, sera). Misurato su 360x640: tra
// striscia dell'offerta, avviso, intestazione, pastiglia e riga dei filtri,
// il fisso sopra l'elenco arrivava a 354px su 640 — il 55% dello schermo, e
// dei file non se ne vedeva quasi nessuno. Un promemoria non vale una fascia
// intera: all'80% lo dice la pastiglia, che quei numeri li ha gia', tingendosi
// di ambra. Qui restano solo i due livelli in cui il caricamento si ferma
// davvero.
//
// Se tutti e due i muri sono in allarme si mostra il piu' grave: due barre
// sovrapposte che dicono due meta' dello stesso problema sono una in piu'.
//
// DOVE STA (2026-09-13, secondo giro). Sul DESKTOP non e' piu' una barra
// fissa in cima allo schermo: sta dentro la colonna del vault, subito sotto
// l'intestazione e sopra l'elenco, larga quanto l'elenco. Cosi' non si somma
// alle altre barre fisse — era quella somma a spingere la prima riga
// dell'elenco sotto il bordo visibile. SUL TELEFONO resta in cima e fissa:
// li' la colonna e' larga quanto lo schermo e dentro l'elenco starebbe
// stretta. La differenza e' la larghezza vera della finestra (700px), non
// Capacitor: in un browser stretto vale la regola del telefono.
//
// DENTRO L'APP L'INVITO NON E' UN TASTO. Un percorso che porta a pagare fuori
// dal sistema di Google, dentro un'app, non e' ammesso: resta la frase che
// dice dove andare. Sul sito — anche dal telefono, nel browser — il tasto c'e'.
import { unitaByte } from '../utils/unita';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { dentroApp as siamoInApp } from '../utils/dentroApp';
import { seguiBarra } from '../utils/barreFisse';
import './BarraSpazio.css';

const STRETTO = '(max-width: 700px)';   /* 700px: la stessa soglia a cui il vault passa alla forma da telefono in App.css */

function peso(byte, lingua) {
  const virgola = lingua === 'en' ? '.' : ',';
  const gb = byte / (1024 * 1024 * 1024);
  if (gb >= 1024) {
    const tb = gb / 1024;
    return (tb === Math.floor(tb) ? String(tb) : tb.toFixed(1)).replace('.', virgola) + ' ' + unitaByte(lingua, 'TB');
  }
  if (gb >= 1) return (gb === Math.floor(gb) ? String(gb) : gb.toFixed(1)).replace('.', virgola) + ' ' + unitaByte(lingua, 'GB');
  return Math.round(byte / (1024 * 1024)) + ' ' + unitaByte(lingua, 'MB');
}

export default function BarraSpazio({ quota, onUpgrade }) {
  const { t, i18n } = useTranslation('vault');
  // Larghezza vera della finestra, non il tipo di dispositivo: una finestra
  // desktop rimpicciolita sotto i 640px ha lo stesso problema del telefono.
  const [stretto, setStretto] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(STRETTO).matches);
  const mia = useRef(null);

  useEffect(() => {
    const mq = window.matchMedia(STRETTO);
    const cambia = (e) => setStretto(e.matches);
    mq.addEventListener('change', cambia);
    return () => mq.removeEventListener('change', cambia);
  }, []);

  const pcSpazio = quota && quota.total > 0 ? (quota.used / quota.total) * 100 : 0;
  const pcFile = quota && quota.maxFiles > 0 ? (quota.fileCount / quota.maxFiles) * 100 : 0;
  // Il piu' grave dei due decide cosa si vede.
  const suiFile = pcFile >= pcSpazio;
  const pc = Math.max(pcSpazio, pcFile);

  const livello = pc >= 100 ? 100 : pc >= 95 ? 95 : 0;
  // Sotto il 95 non c'e' fascia: lo stato lo dice la pastiglia. Sopra, la
  // fascia e' lo stato dell'account e non si chiude.
  const daMostrare = livello > 0;

  // Nel registro delle barre fisse ci entra SOLO quando e' fissa. Da desktop
  // sta nel flusso e non deve spostare niente: registrarla farebbe scendere
  // l'intestazione di un'altezza che nessuno occupa piu'.
  useEffect(() => seguiBarra('avviso', daMostrare && stretto ? mia.current : null),
    [daMostrare, stretto, livello, i18n.language]);

  if (!daMostrare) return null;

  const lingua = i18n.language;
  const dentroApp = siamoInApp();
  const misura = peso(quota.total, lingua);
  const libero = peso(Math.max(0, quota.total - quota.used), lingua);
  const restano = Math.max(0, (quota.maxFiles || 0) - (quota.fileCount || 0));

  // SUL TELEFONO UNA RIGA SOLA (2026-09-13, sera): frase corta piu' tasto.
  // Al muro il perche' lo dicono gia' la pastiglia rossa e il riquadro che
  // compare quando si prova a caricare; la fascia deve solo dire che non si
  // puo' caricare. Misurato: la frase intera col tasto sotto faceva 115px,
  // e da sola portava il fisso sopra l'elenco dal 24% al 42% dello schermo.
  let frase;
  if (stretto) {
    frase = livello === 100
      ? t('fascia_corta_100')
      : suiFile ? t('fascia_corta_95_file', { restano }) : t('fascia_corta_95_spazio', { libero });
  } else if (livello === 100) {
    frase = suiFile
      ? t('muro_file_fisso', { massimo: quota.maxFiles })
      : t('muro_spazio_fisso', { piano: misura });
  } else if (suiFile) {
    frase = t('file_95', { restano, massimo: quota.maxFiles });
  } else {
    frase = t('spazio_95', { percento: Math.min(99, Math.floor(pc)), piano: misura, libero });
  }

  return (
    <div className={`bs-barra ${stretto ? 'bs-fissa' : 'bs-dentro'} bs-grave`} ref={mia} role="status">
      <span className="bs-segno" aria-hidden="true">!</span>
      <span className="bs-testo">
        {frase}
        {livello === 100 && !stretto && (
          <span className="bs-invito">
            {' '}
            {dentroApp ? t('spazio_esaurito_app') : t('muro_passa_piano')}
          </span>
        )}
      </span>
      {!dentroApp && onUpgrade && (
        <button type="button" className="bs-azione" onClick={onUpgrade}>{t('spazio_vedi_piani')}</button>
      )}
    </div>
  );
}
